import React from 'react';

const AboutRocketRock = () => {
    return (
        <div className="text-center md:w-[600px] mx-auto my-20">
            <h1 className="text-center uppercase text-blue-500 text-extrabold text-4xl my-5">About Rocket Rock</h1>
            <p className="text-center text-lg font-extralight">Roceket rock is founded by Iqbal abdullah. in 2022, is works for several spaceship making site. rock makes engines specially. also makes some of the more importatnt tools thant need to be workiing on a making spaceship, Rock worked with visinaries and rocks visons is make the earth sceincetific and most beautiful place in the planet. This is something very important to acknwlage that rock is the first compant that makes engies for rocekt  companies but not flies a rocekt, we are egines makers, Our resposibilies is make your rocket breath.</p>
        </div>
    );
};

export default AboutRocketRock;